import React, { useEffect, useState, useMemo } from "react";
import HeaderTable from "../DataTable/HeaderTable";
import SearchTable from "../DataTable/Search";
import { Link } from "react-router-dom";
import { changeIndexToNepali, colorScale } from "../../utils";
import "./style.css";

export default function NonReportTable({ comments }) {
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const headers = [
    { name: "क्र.स.", field: "id", sortable: false },
    { name: "सूचक", field: "subject", sortable: true },
    { name: "पूर्णाङ्क", field: "value", sortable: true },
    { name: "प्राप्ताङ्क", field: "score", sortable: false },
    { name: "कैैफियत", field: "summary", sortable: false },
  ];
  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search || filter) {
      computedComments =
        computedComments &&
        computedComments.filter(
          (comment) =>
            comment.question &&
            comment.question.toLowerCase().includes(search.toLowerCase())
        );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }
  }, [comments, currentPage, search, sorting]);
  return (
    <div className="row">
      <div className="col col-12 text-center">
        {/* <div className="row table-heading">
          <div className="col d-flex flex-row-reverse dataTables_search">
            <SearchTable
              onSearch={(value) => {
                setSearch(value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div> */}
        <div className="table-responsive">
          <table className="table ">
            <HeaderTable
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {comments &&
                comments.map((p, i) => (
                  <tr>
                    <td key={p.indicator}>
                      {changeIndexToNepali(p.indicator)}
                    </td>
                    <td style={{ textAlign: "left" }}>
                      {p.question}
                    </td>
                    <td>{changeIndexToNepali(p.marks)}</td>
                    <td>{changeIndexToNepali(p.obtained_marks)}</td>
                    <td>{p.remarks}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
